import React from 'react';
import adminImg from 'assets/role-badge/admin.png';
import creatorDanceImg from 'assets/role-badge/creator-dance.png';
import creatorNpcImg from 'assets/role-badge/creator-npc.png';
import creatorOnlineImg from 'assets/role-badge/creator-online.png';
import creatorStudioImg from 'assets/role-badge/creator-studio.png';
import managerImg from 'assets/role-badge/manager.png';
import modImg from 'assets/role-badge/mod.png';
import staffImg from 'assets/role-badge/staff.png';

/**
 * Huy hiệu vai trò — cùng bộ sticker Canva với app (HP-Media
 * library/components/ui/role-badge.tsx, hướng C duyệt 30/09/2026): ban quản
 * trị đội vương miện (Admin vàng · Mod tím · Quản lý xanh), Nhân viên thẻ tên
 * có tim, Creator Online micro, Creator Studio máy ảnh, Creator NPC cô gái tạo
 * dáng, Creator Dance người đang nhảy. Ảnh cắt sát hình, cao 96px, ngang theo
 * tỉ lệ từng hình, viền trắng sẵn; hiển thị cao ≈ 0,85 × cỡ chữ tên (tối thiểu 16).
 * Đổi ảnh ở một bên thì đổi cả bên kia (nguồn: docs/huy-hieu-vai-tro/).
 */
export type RoleBadgeKind =
  | 'ADMIN'
  | 'MOD'
  | 'MANAGER'
  | 'STAFF'
  | 'CREATOR_ONLINE'
  | 'CREATOR_STUDIO'
  | 'CREATOR_NPC'
  | 'CREATOR_DANCE';

export const ROLE_BADGE_LABEL: Record<RoleBadgeKind, string> = {
  ADMIN: 'Admin',
  MOD: 'Mod',
  MANAGER: 'Quản lý',
  STAFF: 'Nhân viên',
  CREATOR_ONLINE: 'Creator Online',
  CREATOR_STUDIO: 'Creator Studio',
  CREATOR_NPC: 'Creator NPC',
  CREATOR_DANCE: 'Creator Dance',
};

const IMAGES: Record<RoleBadgeKind, string> = {
  ADMIN: adminImg,
  MOD: modImg,
  MANAGER: managerImg,
  STAFF: staffImg,
  CREATOR_ONLINE: creatorOnlineImg,
  CREATOR_STUDIO: creatorStudioImg,
  CREATOR_NPC: creatorNpcImg,
  CREATOR_DANCE: creatorDanceImg,
};

/** Ngang / cao của từng ảnh (in ra bởi docs/huy-hieu-vai-tro/cat_huy_hieu.py). */
const RATIO: Record<RoleBadgeKind, number> = {
  ADMIN: 1.087,
  MOD: 1.046,
  MANAGER: 1.09,
  STAFF: 1.048,
  CREATOR_ONLINE: 0.789,
  CREATOR_STUDIO: 1.228,
  CREATOR_NPC: 0.705,
  CREATOR_DANCE: 0.918,
};

interface Props {
  kind: RoleBadgeKind;
  /** CHIỀU CAO ảnh, mặc định 16 */
  size?: number;
}

export const RoleBadge = ({ kind, size = 16 }: Props) => (
  <img
    src={IMAGES[kind]}
    width={Math.round(size * RATIO[kind])}
    height={size}
    alt={`Vai trò: ${ROLE_BADGE_LABEL[kind]}`}
    style={{ flex: '0 0 auto', display: 'block' }}
  />
);
